import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getDairyManureAdditives } from "services";

import { DEFAULT_CACHE_TIME, GET_DAIRY_MANURE_ADDITIVES } from "consts";

import { DairyManureAdditive, WithInjectedName } from "models";

export const useGetDairyManureAdditives = () => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("dairy", { useSuspense: false });

  return useQuery<Array<WithInjectedName<DairyManureAdditive>>>({
    queryKey: [GET_DAIRY_MANURE_ADDITIVES, getDairyManureAdditives],
    queryFn: async () => {
      const manureAdditive = await getDairyManureAdditives();
      return manureAdditive.map((m) => ({ ...m, name: t(`getDairyManureAdditiveTypes.${m.translationSlug}`) }));
    },
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
